import React from 'react'
import { Link } from 'react-router-dom'
import { adminHomeEditUrl } from 'config/constants/urls'
import ListMenuButton from 'src/components/PageActions/ListMenuButton'
import PageActions from 'src/components/PageActions'
import PencilIcon from 'assets/icons/pencil'

const HomeActions = () => (
   <PageActions
      editMenuOptions={(
         <Link to={adminHomeEditUrl}>
            <ListMenuButton
               name="Edit Home Page"
               description="Edit Home page layout and content"
               icon={(
                  <PencilIcon
                     width="16px"
                     height="16px"
                     color="#aaa"
                  />
               )}
            />
         </Link>
      )}
   />
)

export default HomeActions
